import { create } from 'zustand';
import { userService } from '../services/userService';

const useAuthStore = create((set) => ({
  user: null,
  loading: true,
  error: null,
  plan: null,

  setUser: (user) => set({ user, loading: false }),
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error, loading: false }),
  setPlan: (plan) => set({ plan }),

  fetchUser: async () => {
    set({ loading: true });
    try {
      const me = await userService.getMe();
      set({ user: me || null, loading: false });
      return me || null;
    } catch (error) {
      set({ error: error.message, loading: false });
      return null;
    }
  },

  updateUserPlan: async (_uid, plan) => {
    set({ loading: true });
    try {
      // Best-effort local update; backend update may ignore unknown fields
      set((state) => ({ 
        user: state.user ? { ...state.user, plan } : null, 
        plan,
        loading: false 
      }));
      try {
        await userService.updateMe({ plan });
      } catch (_) {
        // ignore if backend does not support plan update
      }
    } catch (error) {
      set({ error: error.message, loading: false });
    }
  },
}));

export default useAuthStore;
